/**
 * Portal area bundle: Bootstrap's JS, the icon font, and the portal stylesheet.
 *
 * Bootstrap is exposed as a global because inline `@push('scripts')` blocks in
 * the portal views run after this bundle and expect `bootstrap` to be there.
 */
import * as bootstrap from 'bootstrap';

import 'bootstrap-icons/font/bootstrap-icons.css';
import '../sass/portal.scss';

window.bootstrap = bootstrap;
